import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Check, Close, TimerOutlined } from '@mui/icons-material';
import { colorSuccess } from '../../../util/constants';
import { TermLink } from '../../../store/modules/merchant/types';

export const ComplianceStatus = ({ status }: { status: TermLink['complianceStatus'] }) => {
  const uiByStatus = {
    APPROVED: {
      text: 'APPROVED',
      color: colorSuccess.text,
      bgColor: colorSuccess.bg,
      icon: <Check sx={{ fontSize: '12px', mt: '1px' }} />,
    },
    REJECTED: {
      text: 'NOT APPROVED',
      color: 'error.dark',
      bgColor: 'error.light',
      icon: <Close sx={{ fontSize: '12px', mt: '1px' }} />,
    },
    PENDING: {
      text: 'APPROVAL PENDING',
      color: 'warning.dark',
      bgColor: 'warning.light',
      icon: <TimerOutlined sx={{ fontSize: '12px', mt: '1px' }} />,
    },
  };

  const uiElements = uiByStatus[status] ?? uiByStatus.PENDING;

  return (
    <Stack>
      <Typography sx={{ fontSize: '12px' }}>Status</Typography>
      <Stack
        direction="row"
        sx={{
          mt: 1,
          borderRadius: '10px',
          color: uiElements.color,
          backgroundColor: uiElements.bgColor,
          py: 0.5,
          px: 1,
        }}
      >
        {uiElements.icon}
        <Typography
          sx={{
            fontSize: '10px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            ml: 0.5,
          }}
        >
          {uiElements.text}
        </Typography>
      </Stack>
    </Stack>
  );
};
